import request from '../../../helpers/request';

const createFacilityTariffs = async (tariffs, facility) => {
  await Promise.all(
    tariffs.map(async (tariff) => {
      return request.post(
        `/RentPlace/rental_house/${facility.id}/tariff`,
        {
          id: 1,
          value: tariff.value,
          tariff: { ...tariff.tariff },
          rentalHouse: { id: facility.id },
        },
        'При создании тарифов произошла ошибка'
      );
    })
  );
};

export default createFacilityTariffs;
